import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datepicker: {
      width: "100%",
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2)
    }
  })
);
